import React from 'react';
import TCAdmin from '../../components/TcAdmin';

const index = () => {
	return (
		<div>
			<TCAdmin />
		</div>
	);
};

export default index;
